import Vue from 'vue';
import VueI18n from 'vue-i18n';
import i18nData from './vivo-messages';

Vue.use(VueI18n);

// Base messages (nav/screens/common/login/home) + per-screen namespaces from
// ./screens/*.js (each `{ ar, en }`), so every C-screen owns its i18n without
// editing the shared vivo-messages.js. `require.context` is a webpack feature.
const messages: any = {
  ar: { ...(i18nData as any).ar },
  en: { ...(i18nData as any).en },
};

const ctx = (require as any).context('./screens', false, /\.js$/);
ctx.keys().forEach((key: string) => {
  const mod = ctx(key);
  const pack = mod && mod.default ? mod.default : mod;
  if (pack && pack.ar) Object.assign(messages.ar, pack.ar);
  if (pack && pack.en) Object.assign(messages.en, pack.en);
});

export default new VueI18n({
  locale: localStorage.lang || 'ar', // Vivo is Arabic-first (RTL)
  fallbackLocale: 'en',
  messages,
});
